import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactGA from 'react-ga'

import Header from '../molecules/Header'
import ProgressBar from '../molecules/ProgressBar'
import { LinkedUserForm } from '../molecules/UserForm'
import { Redirect } from '@reach/router'
import { getBookingState } from '../../store/booking/selectors'
import { getAppPDV } from '../../store/app/selectors'
import { computeUrl } from '../atoms/BackButton'

export class ClientData extends Component {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    const { booking, pdvID } = this.props

    if (booking.services.length === 0) {
      return <Redirect to={computeUrl('/', pdvID)} noThrow />
    }
    if (!booking.selectedHour) {
      return <Redirect to={computeUrl('/seleziona-data', pdvID)} noThrow />
    }
    return (
      <div>
        <Header />
        <ProgressBar activeStep={this.props.activeStep} />
        <LinkedUserForm />
      </div>
    )
  }
}
const mapStateToProps = state => ({
  booking: getBookingState(state),
  pdvID: getAppPDV(state)
})

export const LinkedClientData = connect(mapStateToProps)(ClientData)
